<mat-form-field
  [subscriptSizing]="input.subscriptSizing"
  [appearance]="input.appearance"
  [floatLabel]="input.multiple ? 'always' : 'auto'"
>
  @if (input.label | parse: context | async; as label) {
    <mat-label>{{ label }}</mat-label>
  }
  <mat-select
    [formControl]="_formControl"
    [placeholder]="
      input.multiple
        ? ((input.placeholder | parse: context | async) ??
          (noneSelected() ? 'All' : null))
        : (input.placeholder | parse: context | async)
    "
    [disabled]="input.disabled | parse: context | async"
    [required]="input.required"
    [multiple]="input.multiple"
    (blur)="onBlur($event)"
  >
    @if (input.multiple && (allChecked() || noneSelected())) {
      <mat-select-trigger> All </mat-select-trigger>
    }
    <mat-option>
      <ngx-mat-select-search
        [formControl]="filterCtrl"
        [placeholderLabel]="input.searchPlaceHolder | parse: context | async"
        [noEntriesFoundLabel]="
          input.noEntriesFoundLabel | parse: context | async
        "
      />
    </mat-option>
    @if (input.multiple) {
      <button
        class="mat-mdc-option mdc-list-item mat-mdc-option-multiple full-width"
        matRipple
        (click)="toggleAllSelection()"
      >
        <mat-pseudo-checkbox
          [state]="filteredAllChecked() ? 'checked' : 'unchecked'"
        />
        <span class="mdc-list-item__primary-text">All</span>
      </button>
    }
    @for (
      option of filteredOptions();
      track option[input.optionsValueKey || 'value']
    ) {
      <mat-option [value]="option[input.optionsValueKey || 'value']">
        {{ option[input.optionsLabelKey || 'label'] }}
      </mat-option>
    }
  </mat-select>
  @if (firstFormControlError; as error) {
    <mat-error>
      {{ error.errorMessage | parse: context | async }}
    </mat-error>
  }
</mat-form-field>
